import { lighten } from '@aura/components/styles'
import colors from '../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
        ciro: {
            display: 'flex',
            paddingBottom: '15px'
        },
        ciroImage: {
            height: '28px',
            width: '107.69px'
        },
        ciroImageFr: {
            height: '32px',
            width: '107.69px'
        },
        ciroLink: {
            '&[disabled]': {
                cursor: 'default',
                pointerEvents: 'none'
            },
            alignSelf: 'start',
            color: colors[mode].footerLinkDesColor,
            display: 'block',
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontWeight: 400,
            height: '16px',
            letterSpacing: '0',
            lineHeight: '16px'
        },
        divider: {
            margin: '10px'
        },
        fab: {
            '&:hover': {
                background: lighten('#003168', 0.1)
            },
            '@media screen and (max-width: 500px)': {
                left: 'calc(100% - 15px)',
                top: '12px'
            },
            '@media screen and (min-width: 500px)': {
                top: '20px'
            },
            background: '#003168',
            height: '40px',
            left: 'calc(100% - 10px)',
            width: '40px'
        },
        fabUpArrow: {
            height: '11.82px',
            width: '18px'
        },
        flex: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: '33px'
        },
        footer: {
            '@media screen and (max-width: 500px)': {
                padding: theme.spacing(0, 0, 2, 2),
            },
            background: colors[mode].primaryBackground,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            margin: '0 auto',
            padding: theme.spacing(0, 0, 2, 4),
            width: '100%'
        },
        footerCIRO: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: '1em',
        },
        footerCIROText: {
            '@media screen and (max-width: 450px)': {
                marginTop: '0px'
            },
            marginLeft: '20px',
            marginTop: '10px'
        },
        footerOutter: {
            [theme.breakpoints.down('599')]: {
                padding: theme.spacing(0, 2.5)
            },
            [theme.breakpoints.down('399')]: {
                padding: theme.spacing(0, 1.5)
            },
            backgroundColor: colors[mode].primaryBackground,
            borderTop: `1px solid ${colors[mode].footerBorder}`,
            bottom: 0,
            boxSizing: 'border-box',
            flexShrink: 0,
            left: 0,
            minHeight: 'auto',
            overflowX: 'hidden',
            padding: theme.spacing(0, 4),
            position: 'relative',
            right: 0,
            width: '100%',
            zIndex: 999
        },
        footerRBC: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: '0.5em'
        },
        footerRBCText: {
            marginLeft: '35px'
        },
        footerRBCTextMobileFR: {
            marginLeft: '15px'
        },
        iirocText: {
            margin: '10px 0 0 0'
        },
        keyboardArrowUp: {
            color: '#FFFFFF'
        },
        link: {
            color: colors[mode].footerLinkColor,
            fontFamily: 'Roboto',
            fontSize: '14px',
            height: '16px',
            letterSpacing: 0,
            lineHeight: '16px',
            width: '326px'
        },
        linkBelow: {
            [theme.breakpoints.down('xs')]: {
                marginBottom: '7px'
            },
            marginBottom: '8px'
        },
        linkDisabled: {
            cursor: 'default',
            opacity: 0.95,
            pointerEvents: 'none'
        },
        logo: {
            height: '40px',
            margin: '1em 0 1em 0',
            width: '88px'
        },
        logoContainer: {
            '&:hover': {
                cursor: 'pointer'
            },
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'flex-start',
        },
        logoEn: {
            height: '67px',
            width: '89px'
        },
        logoFr: {
            height: '67px',
            width: '89px'
        },
        scrollTopWrapper: {
            marginRight: '40px'
        },
        svg: {
            height: '23px',
            width: '209px'
        },
        text: {
            [theme.breakpoints.down('xs')]: {
                width: 'calc(100%)'
            },
            '@media screen and (max-width: 450px)': {
                width: '85%'
            },
            color: colors[mode].footerLinkDesColor,
            fontFamily: 'Roboto',
            fontSize: '12px',
            letterSpacing: 0,
            lineHeight: '16px',
            width: '59%'
        },
        usefulLinks: {
            marginTop: '30px'
        },
        verticalLine: {
            borderRight: 'thin solid #eeb234',
            height: '2rem',
            margin: '2rem 2rem'
        }
    }
}